import React from 'react';
// components
import Loader from '../../components/loader';
//////////////////////////////////////////////////

const OAuthPopup = () => <Loader />;

export default OAuthPopup;
